<template>
  <a-card :bordered="false">
    <!-- 搜索表单 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24" v-for="(row, rowIdx) in searchRows" :key="rowIdx">
          <a-col v-for="item in row" :key="item.key" :md="6" :sm="24">
            <a-form-item :label="item.label">
              <component :is="item.type" v-model="queryParam[item.model]" v-bind="item.props"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator"
         style="margin-top: 5px; display: flex; justify-content: space-between; align-items: center;">
      <div style="flex: 1;">
        <a-button type="primary" style="margin-bottom: 16px;" @click="onAddCar">新增车辆</a-button>
      </div>

      <div style="flex: 1; text-align: right;">
        <a-button type="primary" icon="search" @click="searchQuery()" style="margin-right: 8px;">
          查询
        </a-button>
        <a-button icon="reload" @click="searchReset({},0)" style="margin-right: 8px;">
          重置
        </a-button>
<!--        <a @click="handleToggleSearch">-->
<!--          {{ toggleSearchStatus ? $t('antd.table.up') : $t('antd.table.down') }}-->
<!--          <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
<!--        </a>-->
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="table-wrapper">
      <a-table
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          row-key="id"
          @change="handleTableChange"
          :scroll="{ x: 1500 }"
      >
        <span slot="plateNumber" slot-scope="text">
          <span v-if="text" class="car-plate-style">{{ text }}</span>
          <span v-else>-</span>
        </span>
        <span slot="vehicleNumber" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="vehicleIdentificationNumber" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="vehicleBrand" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="vehicleType" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="vehicleStatus" slot-scope="vehicleStatus">
          <a-tag v-if="vehicleStatus" :color="getStatusColor(vehicleStatus)" class="status-tag">
            <a-icon :type="getStatusIcon(vehicleStatus)" style="margin-right: 4px;"/>
            {{ getStatusText(vehicleStatus) }}
          </a-tag>
          <span v-else>-</span>
        </span>
        <span slot="vehicleColor" slot-scope="text">
          <div v-if="text" class="color-display">
            <span class="color-swatch" :style="{ backgroundColor: getColorValue(text) }"></span>
            <span class="color-text">{{ text }}</span>
          </div>
          <span v-else>-</span>
        </span>
        <span slot="maxLoad" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="fuelType" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="fuelConsumption" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="carOwner" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="carOwnerPhone" slot-scope="text">
          {{ text || '-' }}
        </span>

        <span slot="action" slot-scope="text, record">
            <a @click="handleView(record)">查看</a>
            <a-divider type="vertical"/>
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical"/>
            <a-popconfirm :title="$t('antd.table.delectVerify')" @confirm="() => handleDelete(record.id)">
                <a>{{ $t('antd.table.delect') }}</a>
            </a-popconfirm>
        </span>
      </a-table>
    </div>

    <!-- 新增车辆弹窗 -->
    <car-form-modal
        v-if="showAddModal"
        :visible="showAddModal"
        :is-edit="isEdit"
        :vehicle-type-options="vehicleTypeOptions"
        :fuel-type-options="fuelTypeOptions"
        @cancel="handleModalCancel"
        @save="handleModalSave"
        ref="carFormModal"
    />

    <!-- 车辆查看弹窗 -->
    <car-view-modal
        v-if="showViewModal"
        :visible="showViewModal"
        :form="viewForm"
        @cancel="showViewModal=false"
    />
  </a-card>
</template>

<script>
import {message} from 'ant-design-vue';
import {createTrajectoryConfig, updateTrajectoryConfig} from 'api/transport'
import {TableListMixin} from '@/situation/mixins/tableListMixin'
import {getColorValue} from '@/utils/util'
import CarFormModal from './modules/CarFormModal.vue'
import CarViewModal from './modules/CarViewModal.vue'

export default {
  name: "vehicleManage",
  mixins: [TableListMixin],
  components: {
    CarFormModal,
    CarViewModal
  },
  data() {
    return {
      // 查询参数
      queryParam: {},
      isEdit: false,
      // 车辆状态选项 - 按业务流程分类
      vehicleStatusOptions: [
        // 待处理状态
        {value: 'pending', label: '待分配', category: 'pending', color: '#1890ff', icon: 'clock-circle'},
        {value: 'ready', label: '待装车', category: 'pending', color: '#52c41a', icon: 'check-circle'},

        // 进行中状态
        {value: 'loading', label: '装车中', category: 'processing', color: '#faad14', icon: 'loading'},
        {value: 'active', label: '使用中', category: 'processing', color: '#13c2c2', icon: 'car'},
        {value: 'transporting', label: '运输中', category: 'processing', color: '#722ed1', icon: 'rocket'},
        {value: 'maintenance', label: '维修中', category: 'processing', color: '#fa8c16', icon: 'tool'},

        // 完成状态
        {value: 'completed', label: '已完成', category: 'completed', color: '#52c41a', icon: 'check'},
        {value: 'inactive', label: '停用', category: 'completed', color: '#d9d9d9', icon: 'pause-circle'},

        // 异常状态
        {value: 'exception', label: '异常', category: 'exception', color: '#ff4d4f', icon: 'exclamation-circle'},
        {value: 'delayed', label: '延误', category: 'exception', color: '#ff7a45', icon: 'warning'},
        {value: 'scrapped', label: '报废', category: 'exception', color: '#8c8c8c', icon: 'delete'}
      ],



      // 车辆类型选项
      vehicleTypeOptions: [
        {value: '4.2m', label: '4.2m'},
        {value: '6.8m', label: '6.8m'},
        {value: '7.6m', label: '7.6m'},
        {value: '9.6m', label: '9.6m'},
        {value: '13m', label: '13m'},
        {value: '17.5m', label: '17.5m'},
        {value: 'MPV', label: 'MPV'}
      ],
      vehicleCertificateLocationOptions: [
        {value: 0, label: '不在公司'},
        {value: 1, label: '公司内部'}
      ],
      // 燃料类型选项fuelType
      fuelTypeOptions: [
        {value: '柴油', label: '柴油'},
        {value: '汽油', label: '汽油'},
        {value: '混动', label: '混动'},
        {value: '纯电', label: '纯电'}
      ],

      // 表格列配置
      columns: [
        {
          title: '车牌号',
          dataIndex: 'plateNumber',
          key: 'plateNumber',
          width: 160,
          fixed: 'left',
          align: "center",
          scopedSlots: {customRender: 'plateNumber'}
        },
        {
          title: '车辆编码',
          dataIndex: 'vehicleNumber',
          key: 'vehicleNumber',
          align: "center",
          width: 180,
          scopedSlots: {customRender: 'vehicleNumber'}
        },
        {
          title: '车架号',
          dataIndex: 'vehicleIdentificationNumber',
          key: 'vehicleIdentificationNumber',
          align: "center",
          width: 180,
          scopedSlots: {customRender: 'vehicleIdentificationNumber'}
        },
        {
          title: '车辆品牌',
          dataIndex: 'vehicleBrand',
          key: 'vehicleBrand',
          align: "center",
          width: 120,
          scopedSlots: {customRender: 'vehicleBrand'}
        },
        {
          title: '车辆型号',
          dataIndex: 'vehicleType',
          key: 'vehicleType',
          align: "center",
          width: 120,
          scopedSlots: {customRender: 'vehicleType'}
        },
        {
          title: '车辆颜色',
          dataIndex: 'vehicleColor',
          key: 'vehicleColor',
          align: "center",
          width: 120,
          scopedSlots: {customRender: 'vehicleColor'}
        },
        {
          title: '最大载重(吨)',
          dataIndex: 'maxLoad',
          key: 'maxLoad',
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'maxLoad'}
        },
        {
          title: '燃油类型',
          dataIndex: 'fuelType',
          key: 'fuelType',
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'fuelType'}
        },
        {
          title: '百公里油耗(L/100km)',
          dataIndex: 'fuelConsumption',
          key: 'fuelConsumption',
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'fuelConsumption'}
        },
        {
          title: '车主',
          dataIndex: 'carOwner',
          key: 'carOwner',
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'carOwner'}
        },
        {
          title: '车主电话',
          dataIndex: 'carOwnerPhone',
          key: 'carOwnerPhone',
          align: "center",
          width: 120,
          scopedSlots: {customRender: 'carOwnerPhone'}
        },
        {
          title: '车辆状态',
          dataIndex: 'vehicleStatus',
          key: 'vehicleStatus',
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'vehicleStatus'}
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: "center",
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ],
      url: {
        selectData: "/ndt/transportCarInfo/page",
        deleteData: "/ndt/transportCarInfo/delete",
        exportXlsUrl: "/ndt/transportCarInfo/export"
      },
      showAddModal: false,
      toggleSearchStatus: false,
      searchItems: [
        {
          label: '车牌号',
          key: 'plateNumber',
          model: 'plateNumber',
          type: 'a-input',
          props: {placeholder: '请输入车牌号', allowClear: true}
        },
        {
          label: '车辆编号',
          key: 'vehicleNumber',
          model: 'vehicleNumber',
          type: 'a-input',
          props: {placeholder: '请输入车辆编号', allowClear: true}
        },
        {
          label: '车主',
          key: 'carOwner',
          model: 'carOwner',
          type: 'a-input',
          props: {placeholder: '请输入车主姓名', allowClear: true}
        },
        {
          label: '车辆状态',
          key: 'vehicleStatus',
          model: 'vehicleStatus',
          type: 'a-select',
          props: {placeholder: '请选择车辆状态', allowClear: true, options: []}
        },
        // {
        //   label: '车主电话',
        //   key: 'carOwnerPhone',
        //   model: 'carOwnerPhone',
        //   type: 'a-input',
        //   props: {placeholder: '请输入车主电话', allowClear: true}
        // },
        // {
        //   label: '营运证号',
        //   key: 'tradingCardNumber',
        //   model: 'tradingCardNumber',
        //   type: 'a-input',
        //   props: {placeholder: '请输入交易牌号', allowClear: true}
        // },
        // {
        //   label: '车架号',
        //   key: 'vehicleIdentificationNumber',
        //   model: 'vehicleIdentificationNumber',
        //   type: 'a-input',
        //   props: {placeholder: '请输入车架号', allowClear: true}
        // },
        // {
        //   label: '行驶证号',
        //   key: 'drivingPermitNumber',
        //   model: 'drivingPermitNumber',
        //   type: 'a-input',
        //   props: {placeholder: '请输入行驶证号', allowClear: true}
        // },
        // {
        //   label: '车辆类型',
        //   key: 'vehicleType',
        //   model: 'vehicleType',
        //   type: 'a-select',
        //   props: {placeholder: '请选择车辆类型', allowClear: true, options: []}
        // },
        // {
        //   label: '产权所在地',
        //   key: 'vehicleCertificateLocation',
        //   model: 'vehicleCertificateLocation',
        //   type: 'a-select',
        //   props: {placeholder: '请输入车辆证书位置', allowClear: true, options: []}
        // },
      ],
      showViewModal: false,
      viewForm: {},
    }
  },

  computed: {
    searchRows() {
      // 只显示前4个或全部
      const items = this.toggleSearchStatus ? this.searchItems : this.searchItems.slice(0, 4)
      // 按4个一组分组
      const rows = []
      for (let i = 0; i < items.length; i += 4) {
        rows.push(items.slice(i, i + 4))
      }
      return rows
    },


  },
  mounted() {
    // 设置select的options
    this.searchItems.find(i => i.key === 'vehicleStatus').props.options = this.vehicleStatusOptions.map(opt => ({
      label: opt.label,
      value: opt.value
    }))
    this.searchItems.find(i => i.key === 'vehicleType').props.options = this.vehicleTypeOptions.map(opt => ({
      label: opt.label,
      value: opt.value
    }))
    this.searchItems.find(i => i.key === 'vehicleCertificateLocation').props.options = this.vehicleCertificateLocationOptions.map(opt => ({
      label: opt.label,
      value: opt.value
    }))
  },

  methods: {
    // 查看详情
    handleView(record) {
      this.viewForm = {...record}
      this.showViewModal = true
    },

    // 编辑
    handleEdit(record) {
      this.isEdit = true
      this.showAddModal = true
      console.log('record:', record)
      // 等待DOM更新后设置表单数据
      this.$nextTick(() => {
        this.$refs.carFormModal.setFormData(record)
      })
    },
    // 新增车辆按钮
    onAddCar() {
      this.isEdit = false
      this.showAddModal = true
    },
    // 弹框取消
    handleModalCancel() {
      this.showAddModal = false
    },
    // 弹框保存
    async handleModalSave(formData, isEdit) {
      console.log('formData:', formData)
      try {
        if (isEdit) {
          // 调用编辑接口
          const  resp = await updateTrajectoryConfig(formData)
          if (resp.code == '200') {
            message.success('车辆信息更新成功')
          } else {
            message.error(resp?.msg || '车辆信息更新失败')
          }
        } else {
          // 调用新增接口
          const resp = await createTrajectoryConfig(formData)
          if (resp.code == '200') {
            message.success('车辆添加成功');
          } else {
            message.error(resp?.msg || '车辆添加失败')
          }
        }
        this.showAddModal = false
        // 刷新表格数据
        this.loadData()
      } catch (error) {
        console.error('保存车辆信息失败:', error)
        message.error('保存失败，请重试')
      }
    },

    // 获取状态显示文本
    getStatusText(status) {
      const item = this.vehicleStatusOptions.find(item => item.value === status)
      return item ? item.label : status
    },

    // 获取状态标签颜色
    getStatusColor(status) {
      const item = this.vehicleStatusOptions.find(item => item.value === status)
      return item ? item.color : '#d9d9d9'
    },

    // 获取状态图标
    getStatusIcon(status) {
      const item = this.vehicleStatusOptions.find(item => item.value === status)
      return item ? item.icon : 'question-circle'
    },

    // 获取状态分类
    getStatusCategory(status) {
      const item = this.vehicleStatusOptions.find(item => item.value === status)
      return item ? item.category : 'unknown'
    },



    // 获取颜色对应的色值（引用公共方法）
    getColorValue,


  }
}
</script>

<style lang="less" scoped>
/* 可以在这里添加主页面特有的样式 */
.car-plate-style {
  display: inline-block;
  background: #1976d2;
  color: #fff;
  font-weight: bold;
  border-radius: 6px;
  padding: 2px 10px;
  font-size: 15px;
  letter-spacing: 2px;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

/* 颜色显示样式 */
.color-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.color-swatch {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.color-text {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

/* 白色特殊处理，增加边框 */
.color-swatch[style*="#ffffff"],
.color-swatch[style*="white"] {
  border: 1px solid #bfbfbf;
}



/* 状态标签样式优化 */
.status-tag {
  border-radius: 16px;
  font-size: 12px;
  padding: 4px 12px;
  font-weight: 500;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.status-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.status-tag .anticon {
  font-size: 10px;
}
</style>
